import Vue from 'vue'
import Vuetify from 'vuetify'
import VeeValidate from 'vee-validate'
import { createApiClient } from '@bugseq-site/shared/src/lib/api/client'
import App from './App.vue'
import Vuex from 'vuex'
import { createStore } from './store/store'
import 'vuetify/dist/vuetify.min.css'
import '@bugseq-site/shared/src/style.css'
import VueGtag from 'vue-gtag'
import AsyncComputed from 'vue-async-computed'
import VueMeta from 'vue-meta'
import Router from 'vue-router'
import { paths } from '@bugseq-site/www/src/lib/api/api'
import { getApiUrl } from '@bugseq-site/shared/src/env'
import routes from './routes'

Vue.config.productionTip = false

Vue.use(Vuetify, {
  iconfont: ['md', 'mdi', 'fa']
})
Vue.use(VeeValidate)
Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes
})

Vue.use(Vuex)

const client = createApiClient<paths>(getApiUrl())

Vue.use(AsyncComputed)
Vue.use(
  VueGtag,
  {
    config: {
      id: 'UA-129345906-3',
      params: {
        send_page_view: true
      }
    },
    appName: 'www',
    pageTrackerScreenviewEnabled: true
  },
  router
)
Vue.use(VueMeta)

new Vue({
  router,
  store: createStore(client),
  render: (h) => h(App)
}).$mount('#app')
